import React, { useState, useMemo } from "react"
import PropTypes from "prop-types"
import "../../../../../reuseable-components/MultiSelect/style.css"
import { Button, Col, FormControl, Row } from "react-bootstrap"
import GroupOption from "./GroupOption"


export default function GroupMultiSelect(props) {
  // PROPS
  const {
    functionalGroups,
    selectedFunctionalGroups,
    setSelectedFunctionalGroupsFunction,
    mode="add",
    transferSelectedFunctionalGroups,
    selectAllFunctionalGroups
  } = props
  // STATE
  const [searchTerm, setSearchTerm] = useState("")
  const lowerCaseSearchTerm = searchTerm.toLowerCase();

  const handleClick = (userObject) => {
    let updatedGroupList = [...selectedFunctionalGroups]
    const foundGroup = updatedGroupList.find(user => user.id === userObject.id)
    if (foundGroup) {
      updatedGroupList = updatedGroupList.filter(user => user.id !== userObject.id)
    } else {
      updatedGroupList.push(userObject)
    }
    setSelectedFunctionalGroupsFunction(updatedGroupList)
  }

  const filteredAndMappedOptions = useMemo(() => {
    return functionalGroups
      .filter(({ name }) => name.toLowerCase().includes(lowerCaseSearchTerm))
      .map(groupOption => (
        <GroupOption
          key={groupOption.id}
          groupOption={groupOption}
          onClick={() => handleClick(groupOption)}
          selected={!!selectedFunctionalGroups.find(({ id }) => id === groupOption.id)}
        />
      ));
  }, [functionalGroups, lowerCaseSearchTerm, handleClick, selectedFunctionalGroups]);

  return (
    <React.Fragment>
      <FormControl
        value={ searchTerm }
        className="custom-multi-select-option-search"
        onChange={ (e) => setSearchTerm(e.target.value) }
        placeholder="Search"
      />
      <div className="custom-multi-select">
        { filteredAndMappedOptions }
      </div>
      <div>
        <Row className="user-multi-select-action-buttons">
          <Col xs={ 4 } md={ 4 } lg={ 4 }>
            <Button onClick={ () => setSelectedFunctionalGroupsFunction([]) }>Clear</Button>
          </Col>
          <Col xs={ 4 } md={ 4 } lg={ 4 }>
            <Button onClick={ () => selectAllFunctionalGroups(mode, searchTerm) }>Select All</Button>
          </Col>
          <Col xs={ 4 } md={ 4 } lg={ 4 }>
            <Button onClick={ () => transferSelectedFunctionalGroups(mode) } bsStyle={ mode==="add" ? "primary" : "danger" }>{ mode === "add" ? "Add" : "Remove" }</Button>
          </Col>
        </Row>



      </div>
    </React.Fragment>
  )
}


GroupMultiSelect.propTypes = {
  mode: PropTypes.string,
  functionalGroups: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  selectedFunctionalGroups: PropTypes.array.isRequired,
  setSelectedFunctionalGroupsFunction: PropTypes.func.isRequired,
  transferSelectedFunctionalGroups: PropTypes.func.isRequired,
  selectAllFunctionalGroups: PropTypes.func.isRequired,
}


// WEBPACK FOOTER //
// ./src/routes/qms-training/QMSTrainingManager/TrainingContainer/AssignToGroupModal/GroupMultiSelect.js